import React from 'react'

const Product = () => {
    return (
        <section>
            <div className="container">
                <div className="addProduct lg:w-2/3 m-auto rounded-lg shadow-lg border p-5 my-5 ">
                    <h2 className="my-3 text-xl font-bold">Add Product</h2>
                    <form className="space-y-6">
                        <div>
                            <label htmlFor="name" className="block text-sm font-medium leading-6 text-gray-900">Product Name</label>
                            <div className="mt-2">
                                <input id="name" name="name" type="name" required
                                    className="block w-full rounded-md border-0 px-2 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset  sm:text-sm sm:leading-6"
                                />
                            </div>
                        </div>
                        <div>
                            <label htmlFor="price" className="block text-sm font-medium leading-6 text-gray-900">Product Price</label>
                            <div className="mt-2">
                                <input id="price" name="price" type="number" required
                                    className="block w-full rounded-md border-0 px-2 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset  sm:text-sm sm:leading-6"
                                />
                            </div>
                        </div>
                        <div>
                            <label htmlFor="stock" className="block text-sm font-medium leading-6 text-gray-900">Stock</label>
                            <div className="mt-2">
                                <input id="stock" name="stock" type="stock" required
                                    className="block w-full rounded-md border-0 px-2 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset  sm:text-sm sm:leading-6"
                                />
                            </div>
                        </div>

                        <div>
                            <div className="flex items-center justify-between">
                                <label htmlFor="image" className="block text-sm font-medium leading-6 text-gray-900">
                                    Product Image
                                </label>
                            </div>
                            <div className="mt-2">
                                <input id="image" name="image" type="file" required
                                    className="block w-full rounded-md border-0 px-2 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset  sm:text-sm sm:leading-6"
                                />
                            </div>
                        </div>

                        <div>
                            <button type="submit"
                                className="flex px-10 justify-center rounded-md bg-green-600 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
                            >Add
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </section>
    )
}

export default Product